import React from 'react'
import PropTypes from 'prop-types'
import { TweenMax, Power1 } from 'gsap'

class Reveal extends React.PureComponent {
	static propTypes = {
		intialStyles: PropTypes.object,
		finalStyles: PropTypes.object,
		duration: PropTypes.number,
		className: PropTypes.string,
		offset: PropTypes.number
	}

	ticking = false
	windowHeight = typeof window !== 'undefined' && window.innerHeight || 0
	addListeners = this.addListeners.bind(this)
	removeListeners = this.removeListeners.bind(this)
	onScroll = this.onScroll.bind(this)
	onResize = this.onResize.bind(this)
	checkScrollPos = this.checkScrollPos.bind(this)
	Reveal = this.Reveal.bind(this)

	componentDidMount() {
		this.addListeners()
		this.setinitialStyles()
	}

	componentWillUnmount() {
		this.removeListeners()
	}

	setinitialStyles() {
		const values = this.props.initialStyles || {autoAlpha: 0, y: 40}
		TweenMax.set(this.el.children, {...values, onComplete: this.checkScrollPos})
	}

	addListeners() {
		if (typeof window !== 'undefined') {
			window.addEventListener('scroll', this.onScroll)
			window.addEventListener('resize', this.onResize)
		}
	}

	removeListeners() {
		if (typeof window !== 'undefined') {
			window.removeEventListener('scroll', this.onScroll)
			window.removeEventListener('resize', this.onResize)
		}
	}

	onScroll() {
	  if (!this.ticking) {
	  	this.ticking = true
	    this.checkScrollPos()
	  }
	}

	onResize() {
		this.windowHeight = typeof window !== 'undefined' && window.innerHeight || 0
	}

	checkScrollPos() {
		const offset = this.props.offset || 0.9
		if (this.el.getBoundingClientRect().top < (this.windowHeight * offset)) {
			this.Reveal()
		}
		this.ticking = false
	}

	Reveal() {
		const { finalStyles, duration } = this.props
		const values = finalStyles || {autoAlpha: 1, y: 0}
		const dur = duration || 0.7
		TweenMax.staggerTo(this.el.children, dur, {...values, ease: Power1.easeOut}, 0.06, this.removeListeners)
	}

	render() {
		const { className, children } = this.props
		return(
			<div ref={el => this.el = el} className={className}>
				{children}
			</div>
		)
	}
}

export default Reveal


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/Reveal.js